import Header from './components/Header';
import Modal from './components/Modal';
import Logo from './components/Logo';

export default class ComponentFactory {
  constructor() {
    this.componentList = {
      Header,
      Modal,
      Logo,
    };
    this.init();
  }

  init() {
    const components = document.querySelectorAll('[data-component]');

    for (let i = 0; i < components.length; i++) {
      const element = components[i];
      const componentName = element.dataset.component;

      if (this.componentList[componentName]) {
        new this.componentList[componentName](element);
      } else {
        console.log(`La composante ${componentName} n'existe pas`);
      }
    }
  }
}
